<script setup lang="ts">
import { NButton, type ButtonProps } from 'naive-ui'
import { colorTokens } from '../theme/tokens'

// The factory's amber action (Dispatch task, Send to an agent). Naive's
// `warning` type already fills with the amber factory token; this swaps its
// default white label — about 2:1 on amber — for the near-black app body,
// and gives the hover/pressed states amber shades instead of Naive's orange.
// Attributes (data-testid, disabled, loading, @click) fall through to NButton.
const AMBER_HOVER = '#f0b878'
const AMBER_PRESSED = '#d9954a'
const LABEL = colorTokens['surface-bg']

const themeOverrides: NonNullable<ButtonProps['themeOverrides']> = {
  colorHoverWarning: AMBER_HOVER,
  colorPressedWarning: AMBER_PRESSED,
  colorFocusWarning: AMBER_HOVER,
  borderHoverWarning: `1px solid ${AMBER_HOVER}`,
  borderPressedWarning: `1px solid ${AMBER_PRESSED}`,
  borderFocusWarning: `1px solid ${AMBER_HOVER}`,
  textColorWarning: LABEL,
  textColorHoverWarning: LABEL,
  textColorPressedWarning: LABEL,
  textColorFocusWarning: LABEL,
  textColorDisabledWarning: LABEL,
  fontWeight: '600',
}
</script>

<template>
  <NButton type="warning" :theme-overrides="themeOverrides">
    <slot />
  </NButton>
</template>
